import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard, PendingChangesGuard, PrepareGuard } from 'app/core/core.module';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { ReportOpenOrdersComponent } from './report-open-orders/report-open-orders.component';
import { ReportWarrantiesComponent } from './report-warranties/report-warranties.component';
import { CustomerReviewsComponent } from 'app/admin/customer-reviews/customer-reviews.component';
import { StatusReviewComponent } from 'app/orders/status-review/status-review.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'reports',
                component: BasicLayoutComponent,
                children: [
                    { path: 'open-orders', component: ReportOpenOrdersComponent, data: { title: 'Open Orders' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'warranties', component: ReportWarrantiesComponent, data: { title: 'Warranties' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'customer-reviews', component: CustomerReviewsComponent, data: { title: 'Customer Reviews' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'status-review', component: StatusReviewComponent, data: { title: 'Status Review' }, canActivate: [AuthGuard, PrepareGuard] },
                ],
            },
        ]),
    ],
    declarations: [ReportOpenOrdersComponent, ReportWarrantiesComponent, CustomerReviewsComponent, ],
})
export class ReportsModule {}
